import { FolderPlusOutlineIcon } from './FolderPlusOutlineIcon';

/**
 * author: Google
 * id 5615B9DB-A490-4977-9513-B21B086BB542
 * name folder-plus-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-plus-outline.svg
 * tags
 * - Files / Folders 
 */
export const CreateNewFolderOutlineIcon = FolderPlusOutlineIcon;
export default CreateNewFolderOutlineIcon